import React from "react";
import { Box, Card, Typography, Grid } from "@mui/material";
import { DecorativeCorner } from "../common/DecorativeCorner";

const AppSection = ({ styles }) => {
	const heading1Styles = {
		color: "#b38533",
		fontSize: { xs: "16px", sm: "19.78px" }, 
		fontWeight: 700,
				fontFamily: '"Inter var"',

		lineHeight: "100%",
		letterSpacing: "0%",
		textAlign: { xs: "center", sm: "left" }, 
		mb: 1,
	};

	const heading2Styles = {
		color: "#b38533",
		fontSize: { xs: "28px", sm: "37.78px" },
		fontWeight: 700,
		fontFamily: '"Inter var"',
		lineHeight: "100%",
		letterSpacing: "0%",
		textAlign: { xs: "center", sm: "left" }, 
		mb: 2,
	};

	const descriptionStyles = {
		color: "#000000",
		fontSize: { xs: "16px", sm: "19.78px" },
		fontWeight: 400,
				fontFamily: '"Inter var"',

		letterSpacing: "0%",
		lineHeight: "180%",
		textAlign: { xs: "center", sm: "left" }, 
		mb: 1,
	};

	const appStoreButtonStyles = {
		backgroundColor: "#000",
		color: "#fff",
		borderRadius: "8px",
		padding: { xs: "4px 8px", sm: "6px 12px" },
		display: "inline-flex",
		justifySelf: "flex-start",
		mr: 2,
		cursor: "pointer",
	};

	const playStoreButtonStyles = {
		backgroundColor: 'rgba(120, 130, 140, 1)',
		color: "#fff",
		borderRadius: "8px",
		border: "1px solid #ddd",
		padding: { xs: "4px 8px", sm: "6px 12px" },
		display: "inline-flex",
		alignItems: "center",
		cursor: "pointer",
	};

	const phoneContainerStyles = {
		position: "relative",
		height: { xs: "250px", sm: "350px" }, 
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	};

	const phoneFrameStyles = (index) => ({
		position: "absolute",
		// width: { xs: "100px", sm: index === 1 ? "180px" : "160px" }, // Responsive width
		width: {
			xs: index === 1 ? "100px" : "80px",
			sm: index === 1 ? "180px" : "160px",
			md: index === 1 ? "220px" : "200px",
			lg: index === 1 ? "250px" : "230px",
			xl: index === 1 ? "180px" : "160px"
		},

		height: { xs: "200px", sm: index === 1 ? "360px" : "320px" }, 
		borderRadius: "20px",
		border: "1px solid #000000",
		backgroundColor: "#fcf5e9",
		boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: "10px",
		zIndex: index === 1 ? 3 : 2, 
		transform:
			index === 0
				? { xs: "translateX(-80px)", sm: "translateX(-160px)" }
				: index === 2
					? { xs: "translateX(80px)", sm: "translateX(160px)" } 
					: "translateY(0)",
	});

	const appLogoStyles = {
		width: "100%",
		height: "auto",
		objectFit: "contain",
	};

	return (
		<Card
			sx={{
				...styles.payuse,
				height: { xs: "auto", sm: 615 },
				padding: { xs: 2, sm: 4 },
			}}
		>
			<DecorativeCorner
				sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
			/>
			<DecorativeCorner
				sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
			/>
			<DecorativeCorner
				sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
			/>
			<DecorativeCorner
				sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
			/>
			<Typography variant="h4" component="h1" sx={styles.heading}>
				Our Application						</Typography>

			<Grid container spacing={3}>
				<Grid
					item
					xs={12}
					md={6}
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: { xs: "center", sm: "flex-start" },
					}}
				>
					<Typography variant="subtitle1" sx={heading1Styles}>
						STAY CONNECTED WITH
					</Typography>

					<Typography variant="h5" component="h3" sx={heading2Styles}>
						Annapurna Marriages Apps
					</Typography>

					<Typography variant="body1" sx={descriptionStyles}>
						Access quick & simple search, instant updates and a great user
						experience on your phone. Download our apps rated best in the online
						matrimony segment.
					</Typography>
					<Box
						sx={{
							mt: 2,
							textAlign: { xs: "center", sm: "left" },
							display: "flex",
							flexDirection: { xs: "column", sm: "row" },
							alignItems: "center",
							gap: { xs: 1, sm: 2 },
						}}
					>
						<Box
							component="a"
							sx={{
								...appStoreButtonStyles,
								display: "flex",
								alignItems: "center",
								gap: { xs: 0.5, sm: 1 },
								marginLeft:{xs:"15px"}
							}}
						>
							<img
								src="/images/appleicon.png"
								alt="App Store"
								style={{ height: "25px",}}
							/>
							<Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
								<Typography sx={{ fontSize: { xs: "10px", sm: "12px" }, fontWeight: 400 }}>
									Download now
								</Typography>
								<Typography sx={{ fontSize: { xs: "12px", sm: "14px" }, fontWeight: "bold" }}>
									App Store
								</Typography>
							</Box>
						</Box>

						<Box
							component="a"
							sx={{
								...playStoreButtonStyles,
								display: "flex",
								alignItems: "center",
								gap: { xs: 0.5, sm: 1 },
							}}
						>
							<img
								src="/images/playstoreicon.png"
								alt="Google Play"
								style={{ height: "25px" }}
							/>
							<Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
								<Typography sx={{ fontSize: { xs: "10px", sm: "12px" }, fontWeight: 400 }}>
									Download now
								</Typography>
								<Typography sx={{ fontSize: { xs: "12px", sm: "14px" }, fontWeight: "bold" }}>
									Google Play
								</Typography>
							</Box>
						</Box>
					</Box>

				</Grid>

				<Grid item xs={12} md={6}>
					<Box sx={phoneContainerStyles}>
						{[0, 1, 2].map((index) => (
							<Box key={index} sx={phoneFrameStyles(index)}>
								<img
									src="\images\Frame 148.png"
									alt={`App Screenshot ${index + 1}`}
									style={appLogoStyles}
								/>
							</Box>
						))}
					</Box>
				</Grid>
			</Grid>
		</Card>
	);
};

export default AppSection;